import { useTranslation } from 'react-i18next'
import { Target, CheckCircle2 } from 'lucide-react'
import { cn } from '@/lib/utils'
import { useWeeklyGoal } from '@/hooks/use-gamification'

export function WeeklyGoalCard() {
  const { t } = useTranslation()
  const { data, isLoading } = useWeeklyGoal()

  if (isLoading || !data) {
    return <div className="bg-surface-container-low h-28 animate-pulse rounded-xl" />
  }

  return (
    <section className="space-y-3">
      <div className="flex items-center gap-2">
        <Target className="text-primary h-4 w-4" />
        <h2 className="font-heading text-base font-bold">
          {t('gamification.weeklyGoal', 'Weekly Goal')}
        </h2>
        {data.completed && (
          <CheckCircle2 className="text-chartreuse-foreground dark:text-chartreuse h-4 w-4" />
        )}
      </div>
      <div className="bg-surface-container-low rounded-xl p-4">
        <div className="mb-2 flex items-baseline justify-between">
          <span className="text-sm font-medium">
            {t('gamification.reachOut', 'Reach out to {{goal}} people', { goal: data.goal })}
          </span>
          <span
            className={cn(
              'text-lg font-bold',
              data.completed ? 'text-chartreuse-foreground dark:text-chartreuse' : 'text-primary',
            )}
          >
            {data.progress}/{data.goal}
          </span>
        </div>

        {/* Progress bar */}
        <div className="bg-surface-container-highest h-3 overflow-hidden rounded-full">
          <div
            className={cn(
              'h-full rounded-full transition-all duration-500',
              data.completed ? 'bg-chartreuse' : data.percentage >= 60 ? 'bg-primary' : 'bg-coral',
            )}
            style={{ width: `${data.percentage}%` }}
          />
        </div>

        <p className="text-on-surface-variant mt-2 text-xs">
          {data.completed
            ? t('gamification.goalComplete', 'Goal complete! Keep it up!')
            : t('gamification.goalRemaining', '{{count}} more to go this week', {
                count: data.goal - data.progress,
              })}
        </p>
      </div>
    </section>
  )
}
